import { render, staticRenderFns } from "./byRegulator.vue?vue&type=template&id=d0be7afa"
import script from "./byRegulator.vue?vue&type=script&lang=js"
export * from "./byRegulator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports